import React from 'react'
import { connect } from 'react-redux'
import { getObjectItem, getTranslation, getPriceList } from '../../actions/dataActions'
import TitleBarButton from '../../components/TitleBarButton'
import TicketScanner from '../../ticket/TicketScanner';

function TicketScannerButton(propsModal) {
        const { width, height, top, left } = propsModal;
        let style = {
            width: `${width}%`,
            height: `${height}%`,
            top: `${top}%`,
            left: `${left}%`,
            fontSize: `20px`,
        };
        return (
          <div style={style} id="app" className="ticket-scanner">
          <TitleBarButton />
          <div className="ticket-scanner-container">
            <TicketScanner />
          </div>
        </div>
        )
    }


function mapStateToProps(state) {
    return {
    }
}

export default connect(mapStateToProps, { getObjectItem, getTranslation, getPriceList })(TicketScannerButton)


// WEBPACK FOOTER //
// src/freeformat/components/TicketScannerButton.jsx